/**
 * Alert functionality
 * @class
 */
export default class Alert {
    /**
     * @constructor
     * @param {HTMLElement} element The alert root element
     */
    constructor(element) {
        this.element = element;
        this.trigger = element.querySelector('[data-button="CloseAlert"]');
        this.html = document.querySelector('html');
        //get data attribute that displays the last date this content was updated
        const datePublished = element.dataset.update;
        //check if alert is same as the one saved in localStorage
        if (localStorage.getItem('alert') !== datePublished) {
            element.classList.remove('hide');
            localStorage.removeItem('alert');
        }
        else {
            element.classList.add('hide');
        }
        this.trigger.addEventListener('click', () => {
            element.classList.add('hide');
            if (datePublished) {
                localStorage.setItem('alert', datePublished);
            }
        });
    }
    /**
     * Creates new instance of Alert element,
     * and adds the necessary event listeners to support opening and closing of the alert message.
     */
    static init() {
        const alert = document.querySelector('[data-component="Alert"');
        if (alert)
            return new Alert(alert);
    }
}
